import gql from 'graphql-tag';

const getCatalogs = gql`
  query {
    catalogs(pagination: { pageSize: 500 }) {
      data {
        id
        attributes {
          name
          position
          catalogs(sort: "position", pagination: { pageSize: 500 }) {
            data {
              id
              attributes {
                name
              }
            }
          }
          services(sort: "position", pagination: { pageSize: 500 }) {
            data {
              id
              attributes {
                name
                slug
                external_id
                external_link
                contact_by_chat
                data_source
                selfservice {
                  data {
                    id
                    attributes {
                      slug
                    }
                  }
                }
                incident {
                  data {
                    id

                    attributes {
                      publishedAt
                    }
                  }
                }
              }
            }
          }
          parent {
            data {
              id
            }
          }
        }
      }
    }

    services(
      sort: "position"
      filters: { catalogs: { id: { null: true } } }
      pagination: { pageSize: 500 }
    ) {
      data {
        id
        attributes {
          name
          slug
          external_id
          position
          data_source
          contact_by_chat
          is_login_required
          external_link
          selfservice {
            data {
              id
              attributes {
                slug
              }
            }
          }
          incident {
            data {
              id
              attributes {
                publishedAt
              }
            }
          }
        }
      }
    }
  }
`;

export default getCatalogs;
